<template>
  <v-app>
    <AutoLogout v-if="fromPHistory=='Yes'"></AutoLogout>
    <v-toolbar class="col-xs-12" app height="45">
      <div v-if="fromPHistory=='Yes'">
        <a @click="backToPurchHistory()">
          <v-icon style="font-size:30px;padding-left:2.5px;padding-top:2px;">arrow_back</v-icon>
        </a>
      </div>
      <div>
        <h3 style="margin:0px;margin-left:20px;">Order Details</h3>
      </div>
    </v-toolbar>
    <v-container style="margin-top:45px;">
      <div v-if="errorToken == false">
        <div class="col-xs-12">
          <div class="list-group-item clearfix">
            <h3 class="TrnHdr" style="overflow-wrap: break-word;">{{orderRefNo}}</h3>
            <h3 class="TrnHdr">{{fullSchdDate}} {{fullSchdTime}}</h3>
            <h3 class="TrnHdr">Schd Type : {{schdType}}</h3>
          </div>
          <br />

          <!-- <hr style="border:1px solid"> -->
          <div class="list-group-item clearfix">
            <h3 class="TrnHdr" style="overflow-wrap: break-word;">Name : {{custName}}</h3>
            <h3
              v-if="custEmail != ''"
              class="TrnHdr"
              style="overflow-wrap: break-word;"
            >Email : {{custEmail}}</h3>
            <h3 class="TrnHdr">Phone No : {{custPhNo}}</h3>
            <h3 v-if="custPax>0" class="TrnHdr">Pax : {{custPax}}</h3>
            <h3
              v-if="custAddress != ''"
              style="overflow-wrap: break-word;"
              class="TrnHdr"
            >Address : {{custAddress}}</h3>
            <h3
              v-if="custMemo != ''"
              style="overflow-wrap: break-word;"
              class="TrnHdr"
            >Memo : {{custMemo}}</h3>
          </div>
          <br />
          <!-- <hr style="border:1px solid"> -->
          <div class="list-group-item clearfix">
            <span style="float: right; min-width:65%;text-align:right;"></span>
            <span style="float: right; min-width:25%;text-align:right;">
              <strong>RM</strong>
            </span>
            <span style="float: right; min-width:10%;text-align:right;">
              <strong>Qty</strong>
            </span>
          </div>
          <div class="col-xs-12" style="padding:0px;">
            <a v-for="x of listOfTrnDtl" :key="x.ID" class="list-group-item clearfix">
              <div class="col-xs-12 pull-left" style="padding: 0;">
                <img style="float: left; max-width:15%;margin-right:10px;" :src="x.imgSmall" />
                <h5
                  v-if="x.size != '#' "
                  class="list-group-item-text itemDetails"
                  style="min-width:65%;"
                >
                  {{ x.prdtName }}
                  <!-- ( {{ x.size }} ) -->
                  <span
                    style="float: right; min-width:25%;text-align:right;"
                  >{{ x.amount.toFixed(2) }}</span>
                  <span style="float: right; min-width:10%;text-align:right;">{{x.qty}}</span>
                </h5>

                <h5
                  v-if="x.size == '#' "
                  class="list-group-item-text itemDetails"
                  style="min-width:65%;"
                >
                  {{ x.prdtName }}
                  <span
                    style="float: right; min-width:25%;text-align:right;"
                  >{{ x.amount.toFixed(2) }}</span>
                  <span style="float: right; min-width:10%;text-align:right;">{{x.qty}}</span>
                </h5>
                <!-- <h4 class="list-group-item-text">Quantity : {{ x.qty }}</h4>
                <h4 class="list-group-item-text">Amount : {{ x.amount.toFixed(2) }}</h4>-->
                <h5 class="list-group-item-text itemDetails">{{ x.memo }}</h5>
                <h5 class="list-group-item-text itemDetails">{{ x.propList }}</h5>
              </div>
            </a>
            <!-- <hr style="border:1px solid"> -->
          </div>
          <br />

          <div class="col-xs-12" style="padding:0px;">
            <div class="list-group-item clearfix">
              <span style="float: right; min-width:150px;text-align:right;">
                <strong>RM</strong>
              </span>
            </div>

            <div class="list-group-item clearfix">
              <h3 class="TrnHdr">
                Subtotal :
                <span style="float: right; ">{{subtotal.toFixed(2)}}</span>
              </h3>
              <h3 v-if="SvcAmt != 0" class="TrnHdr">
                Service Charge :
                <span style="float: right; ">{{SvcAmt.toFixed(2)}}</span>
              </h3>
              <h3 v-if="TaxAmt != 0" class="TrnHdr">
                Tax :
                <span style="float: right; ">{{TaxAmt.toFixed(2)}}</span>
              </h3>
              <h3 v-if="DeliveryChg != 0" class="TrnHdr" style="font-size:16px;">
                Delivery Charges :
                <span style="float: right; ">{{DeliveryChg.toFixed(2)}}</span>
              </h3>
              <hr style="border:0.5px solid gainsboro" />

              <h2 class="grandTotal">
                Total :
                <span style="float: right; ">RM {{roundAmt.toFixed(2)}}</span>
              </h2>
              <hr style="border:0.5px solid gainsboro; margin-top:10px; margin-bottom:10px;" />
              <hr style="border:0.5px solid gainsboro; margin-top:10px; margin-bottom:10px;" />
              <h2 class="grandTotal">
                Paid Amount :
                <span style="float: right; ">RM {{paidAmt.toFixed(2)}}</span>
              </h2>
              <hr style="border:0.5px solid gainsboro; margin-top:10px; margin-bottom:10px;" />
              <hr style="border:0.5px solid gainsboro; margin-top:10px; margin-bottom:10px;" />
            </div>
            <!-- <hr style="border:1px solid"> -->
          </div>
        </div>
      </div>

      <div v-if="errorToken">
        <h2 class="errorTxt">Record Not Found</h2>
      </div>
    </v-container>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
import JsonService from './JsonService'
import globalVar from './GlobalVar.js'
import VersionDialog from '../src/VersionNotMatchDialog'
import AutoLogout from './AutoLogout'
export default {
  components: {
    AutoLogout,
    VersionDialog
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['token'],
  data() {
    return {
      fromPHistory: 'No',
      errorToken: false,
      orderRefNo: '',
      fullSchdDate: '',
      fullSchdTime: '',
      schdType: '',
      custName: '',
      custEmail: '',
      custPhNo: '',
      custAddress: '',
      custMemo: '',
      custPax: 0,
      listOfTrnDtl: [],
      subtotal: 0,
      SvcAmt: 0,
      TaxAmt: 0,
      DeliveryChg: 0,
      roundAmt: 0,
      paidAmt: 0,
      versionError: false
    }
  },
  computed: {
    getCSSwith(key) {
      return this.$store.state.svrCSS[key]
    }
  },
  created: function() {
    sessionStorage.setItem('needBackPrevPosition', false)
    console.log(this.token)
    this.fromPHistory = sessionStorage.getItem('fromPHistory')
    this.getOrderListByToken()
  },
  destroyed() {
    console.log('destroy')
  },
  methods: {
    getOrderListByToken() {
      if (this.validURL(this.token)) {
        this.versionError = false
        var version = sessionStorage.getItem('version')
        let url = 'Order/ViewOrder'
        let para = {
          av: version,
          ml: this.token
        }
        JsonService.request(url, para)
          .then(res => {
            console.log('res', res.data)
            if (
              res.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
              res.data == 'Version Not Match'
            ) {
              this.versionError = true
            } else {
              this.versionError = false
              if (res.data.ListOfTrnHdr) {
                this.orderRefNo = ''
                this.fullSchdDate = ''
                this.fullSchdTime = ''
                this.schdType = ''
                this.custName = ''
                this.custEmail = ''
                this.custPhNo = ''
                this.custAddress = ''
                this.custMemo = ''
                this.custPax = 0
                this.SvcAmt = 0
                this.TaxAmt = 0
                this.DeliveryChg = 0
                this.roundAmt = 0
                this.paidAmt = 0
                this.getListOfTrnHdr(res.data.ListOfTrnHdr[0])
                this.getListOfTrnDtl(res.data.ListOfTrnDtl)
              } else {
                console.log(res.data)
                this.errorToken = true
              }
            }
          })
          .catch(err => {
            console.log('err', err)
            this.versionError = false
            alert(err)
            // this.$store.dispatch("updateValidState", 2)
          })
      }
    },
    validURL(token) {
      console.log('Token: ', token)
      if (token === null || token === '' || typeof token === 'undefined') {
        return false
      }
      return true
    },
    getListOfTrnHdr(data) {
      this.orderRefNo = data.oa
      this.fullSchdDate = new Date(data.mx)
        .toLocaleDateString('en-GB')
        .substr(0, 10)
      this.fullSchdTime = new Date(data.mx).toLocaleTimeString()
      let btnName = JSON.parse(sessionStorage.getItem('SchdTypeBtnName'))
      if (data.mw == 1) {
        if (btnName.DineIn == '') {
          this.schdType = 'Dine In, Pre-order'
        } else {
          this.schdType = btnName.DineIn
        }
      } else if (data.mw == 2) {
        if (btnName.TakeAway == '') {
          this.schdType = 'Take Away'
        } else {
          this.schdType = btnName.TakeAway
        }
      } else if (data.mw == 3) {
        if (btnName.Delivery == '') {
          this.schdType = 'Delivery'
        } else {
          this.schdType = btnName.Delivery
        }
      } else if (data.mw == 4) {
        if (btnName.ScanOrder == '') {
          this.schdType = 'Dine In, Scan, Order'
        } else {
          this.schdType = btnName.ScanOrder
        }
      }
      this.custName = data.ez
      this.custEmail = data.ly
      this.custPhNo = data.y
      this.custMemo = data.dy
      this.custAddress = data.en
      this.custPax = data.ot
      this.SvcAmt = data.oh
      this.TaxAmt = data.og
      this.DeliveryChg = data.rs
      this.roundAmt = data.oj
      this.paidAmt = data.lh
    },
    getListOfTrnDtl(data) {
      this.listOfTrnDtl = []
      this.subtotal = 0
      console.log(data.length)
      for (let i = 0; i < data.length; i++) {
        if (data[i].kw == '') {
          var defaultImg = require('./assets/ImgNotFound.png')
          data[i].kw = defaultImg
        } else {
          data[i].kw = JsonService.checkImg(data[i].kw)
        }
        const ListOfPrdDetail = {
          qty: data[i].lo,
          prdtName: data[i].ll,
          amount: data[i].lt,
          size: data[i].lm,
          memo: data[i].ln,
          imgSmall: data[i].kw,
          propList: data[i].lm
        }
        this.subtotal += ListOfPrdDetail.amount
        this.listOfTrnDtl.push(ListOfPrdDetail)
      }
      console.log(this.subtotal)
      console.log(this.listOfTrnDtl)
    },
    backToPurchHistory() {
      if (globalVar.mode == 'normal') {
        this.$router.replace('/PurchaseHistory')
      } else if (globalVar.mode == 'lite') {
        var mchCd = sessionStorage.getItem('paramMchdCode')
        this.$router.replace({
          name: 'PurchaseHistory',
          params: { mchdCode: mchCd }
        })
      }
    }
  }
}
</script>

<style>
.errorTxt {
  font-size: 35px;
  margin-top: 10%;
}

.TrnHdr {
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 5px;
}

@media (max-width: 600px) {
  .itemDetails {
    min-width: 60%;
  }
}

@media (max-width: 500px) {
  .TrnHdr {
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 5px;
  }
  .grandTotal {
    font-size: 22px;
  }
}
</style>
